import { AuthLayout } from '@ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Brand } from '../../../app/Brand';
import { useMeta } from '../../system/useMeta';

/** Frame for pages without session: sign-in, links from e-mails. Shows the business name. */
export function PublicPage({
  title,
  description,
  background,
  children,
}: {
  title: string;
  description?: ReactNode;
  /** Decorative background, only the sign-in page sets it. */
  background?: ReactNode;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const meta = useMeta();
  return (
    <AuthLayout
      brand={<Brand large business={meta.data?.business_name} />}
      title={title}
      {...(description ? { description } : {})}
      {...(background ? { background } : {})}
      footer={
        <>
          {t('auth.footer')}{' '}
          <a href="https://github.com/andreashigel/swarm" target="_blank" rel="noreferrer">
            {t('about.sourceCode')}
          </a>
        </>
      }
    >
      {children}
    </AuthLayout>
  );
}
